import { render, staticRenderFns } from "./widget-image.vue?vue&type=template&id=448c863e&scoped=true"
import script from "./widget-image.vue?vue&type=script&lang=ts"
export * from "./widget-image.vue?vue&type=script&lang=ts"
import style0 from "./widget-image.vue?vue&type=style&index=0&id=448c863e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448c863e",
  null
  
)

export default component.exports